import { useRouter } from "next/router";

export function ReloadPageButton({ children }: { children: React.ReactNode }) {
  const router = useRouter();

  return (
    <button
      type="button"
      onClick={() => router.reload()}
      className="text-red-600"
    >
      {children}
    </button>
  );
}

type ErrorPageContentProps = {
  statusCode?: number;
  message?: string;
  children?: React.ReactNode;
};

export function ErrorPageContent({
  statusCode,
  message,
  children,
}: ErrorPageContentProps) {
  const displayMessage = (() => {
    if (message) {
      return message;
    } else if (children) {
      return children;
    } else if (statusCode === 404) {
      return "We couldn't find that page. Sorry!";
    } else {
      return "Something went wrong. If this happens again, please contact us.";
    }
  })();

  return (
    <div className="pt-24 text-center">
      <h3>{displayMessage}</h3>
    </div>
  );
}
